import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

// kind: 'returns' | 'free-shoes'
export async function listRiderReports(kind, status, offset = 0, limit = 50) {
  const res = await axios.get(`${API}/rider-reports/${kind}`, {
    headers: authHeader(), params: { status, offset, limit },
  });
  return res.data;
}

export async function reviewRiderReport(kind, id, action, note) {
  const res = await axios.post(`${API}/rider-reports/${kind}/${id}/${action}`,
    { note: note || null }, { headers: authHeader() });
  return res.data;
}

// barcodes omitted/null = every pending return
export async function bulkConfirmReturns(barcodes) {
  const res = await axios.post(`${API}/rider-reports/returns/bulk-confirm`,
    { barcodes: barcodes || null }, { headers: authHeader() });
  return res.data;
}

export async function confirmAllFreeShoes() {
  const res = await axios.post(`${API}/rider-reports/free-shoes/confirm-all`,
    { note: null }, { headers: authHeader() });
  return res.data;
}

export async function fixFreeShoeBarcode(id, barcode) {
  const res = await axios.post(`${API}/rider-reports/free-shoes/${id}/fix-barcode`,
    { barcode }, { headers: authHeader() });
  return res.data;
}

export async function adminAddReturns(payload) {
  const res = await axios.post(`${API}/rider-reports/returns/admin-add`,
    payload, { headers: authHeader() });
  return res.data;
}
